import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HtmlList from './icon-html-list.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HtmlList {...validProps} />;
}
SvgComponent.iconName = 'html-list';

/**
 * @deprecated This is a legacy icon
 */
export const HtmlListIcon = svgIconWrapper(SvgComponent);
